module.exports = __webpack_public_path__ + "img/logo_instagram.74bbb9e5.png";